import Menu from './Compartido/Menu.jsx';
import GuestPreferencesForm from './Preferencias/GuestPreferencesForm.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Politicas = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="4_Contacto"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <GuestPreferencesForm
                reserva={props.reserva}
                lang={props.lang}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Politicas;

